export default class PageLayout {
  static get Communities() {
    return this.getInstance('communities-communities');
  }

  static get Homes() {
    return this.getInstance('homes-homes');
  }

  static get Builders() {
    return this.getInstance('AllProducts-builders');
  }
    
  static get BoylLocations() {
    return this.getInstance('boyl-locations');
  }

  static get CustomHomes() {
    return this.getInstance('custom-homes');
  }

  static fromKey(key) {
    const statusMap = {
      'communities-communities': PageLayout.Communities,
      'homes-homes': PageLayout.Homes,
      'AllProducts-builders': PageLayout.Builders,
      'boyl-locations': PageLayout.BoylLocations,
      'custom-homes': PageLayout.CustomHomes,
    };
    return statusMap[key];
  }

  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new PageLayout(key);
    }
    return this.instances[key];
  }

  constructor(name) {
    this.name = name;
  }

  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(PageLayout, 'instances', { value: {} });
